<template>
  <ModalBase :show="show" @close="close()">
    <h3 class="modal-heading">Ring</h3>
    <div class="modal-phone-numer">
      <a class="button-base modal-phone-number-link" :href="'tel:' + phoneNumber">{{ phoneNumber }}</a>
    </div>
  </ModalBase>
</template>

<script>
import ModalBase from '@/components/ModalBase.vue'

export default {
  name: 'Phone',
  props: ['show', 'phoneNumber'],
  components: {
    ModalBase
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/modules/_variables.scss';

.modal-phone-number-link {
  background-color: map-get($colors, yellow-lighter);
  border-radius: 50px;
  color: map-get($colors, yellow-darkest);
  font-size: 2.4rem;
  font-weight: 700;
  padding: 16px;
  text-align: center;
  display: block;
}
</style>
